import SectionHeader from "./SectionHeader";
import Reveal from "./Reveal";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

const residential = [
  { id: "residential", label: "Residential", href: "#residential", title: "GET YOUR HOME BACK.",
    targets: ["Houses", "Condos", "Apartments", "Townhomes", "Rental properties"],
    copy: "Clear booking. Clear preparation. Professional treatment.", cta: "Book Residential Treatment" },
  { id: "managers", label: "Property Managers", href: "#managers", title: "BED BUGS DON'T STOP AT YOUR TENANT'S DOOR.",
    targets: [], copy: "Protecting your buildings, your tenants and your reputation across multiple units.",
    cta: "Property Manager Services",
    list: ["Unit Treatment", "Multi-Unit Coordination", "Treatment Documentation", "Tenant Preparation Instructions", "Follow-Up Treatment", "Recurring Service Programs"] },
  { id: "hotels", label: "Hotels & STR", href: "#hotels", title: "ONE COMPLAINT CAN BECOME A BUSINESS PROBLEM.",
    targets: [], copy: "Positioned as your professional treatment partner for hotels and short-term rentals.",
    cta: "Commercial Bed Bug Treatment",
    list: ["Guest complaints", "Refund requests", "Poor reviews", "Operational disruption", "Reputational damage"] }
];

export default function PropertySections() {
  return (
    <>
      {/* Residential */}
      <section id="residential" className="border-b border-border bg-background px-5 py-24 lg:px-8 lg:py-32">
        <div className="mx-auto max-w-7xl">
          <SectionHeader kicker="Residential" title="GET YOUR HOME BACK." />
          <div className="mt-10 flex flex-wrap gap-2.5">
            {residential[0].targets.map((t) => (
              <span key={t} className="rounded-full border border-border bg-muted/40 px-4 py-1.5 text-xs font-medium text-foreground">{t}</span>
            ))}
          </div>
          <p className="mt-6 max-w-xl text-lg leading-relaxed text-muted-foreground">{residential[0].copy}</p>
          <Reveal delay={0.05}>
            <Button asChild size="lg" className="mt-8 h-12 px-8 text-sm font-semibold tracking-wide bg-accent text-white hover:bg-accent/90">
              <a href="#booking">{residential[0].cta} <ArrowRight className="ml-1 h-4 w-4" /></a>
            </Button>
          </Reveal>
        </div>
      </section>

      {/* Property Managers */}
      <section id="managers" className="border-b border-border bg-primary px-5 py-24 text-white lg:px-8 lg:py-32">
        <div className="mx-auto max-w-7xl">
          <SectionHeader dark kicker="Property Managers" title="BED BUGS DON'T STOP AT YOUR TENANT'S DOOR." subtitle="A single-unit issue can travel through connected living environments. We help landlords and property managers coordinate treatment across units — without claiming to inspect adjacent units unless arranged." />
          <div className="mt-12 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
            {residential[1].list.map((item, i) => (
              <Reveal key={item} delay={i * 0.04}>
                <div className="flex h-full items-center gap-3 rounded-md border border-white/10 bg-white/[0.03] px-5 py-4">
                  <span className="h-1.5 w-1.5 rounded-full bg-accent" />
                  <span className="text-sm font-medium">{item}</span>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.1}>
            <Button asChild size="lg" className="mt-10 h-12 border-white/30 bg-transparent px-8 text-sm font-semibold tracking-wide text-white hover:bg-white/10 hover:text-white" variant="outline">
              <a href="#booking">{residential[1].cta}</a>
            </Button>
          </Reveal>
        </div>
      </section>

      {/* Hotels & STR */}
      <section id="hotels" className="border-b border-border bg-background px-5 py-24 lg:px-8 lg:py-32">
        <div className="mx-auto max-w-7xl">
          <SectionHeader kicker="Hotels & Short-Term Rentals" title="ONE BED BUG COMPLAINT CAN BECOME A BUSINESS PROBLEM." subtitle="For hospitality, speed and discretion protect more than a room — they protect your reputation." />
          <div className="mt-12 grid gap-4 md:grid-cols-2 lg:grid-cols-5">
            {residential[2].list.map((item, i) => (
              <Reveal key={item} delay={i * 0.05}>
                <div className="h-full rounded-lg border border-border bg-muted/30 p-6">
                  <span className="font-heading text-2xl font-extrabold text-muted-foreground/30 tnum">0{i + 1}</span>
                  <p className="mt-3 text-sm font-medium text-foreground">{item}</p>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.1}>
            <Button asChild size="lg" className="mt-10 h-12 px-8 text-sm font-semibold tracking-wide bg-accent text-white hover:bg-accent/90">
              <a href="#booking">{residential[2].cta} <ArrowRight className="ml-1 h-4 w-4" /></a>
            </Button>
          </Reveal>
        </div>
      </section>
    </>
  );
}